import DialogPrimitive from './dialog.primitive';

const pkg: {
  Dialog: typeof DialogPrimitive;
} = {
  Dialog: DialogPrimitive,
};

export default pkg;
